import * as React from 'react';

import ShareButtonIcon from './ShareButtonIcon';
import type { IShareButtonProps } from '../../../types';
import getPlatformIdWithFallback from '../../../utils/getPlatformIdWithFallback';
import {
  platformIds,
  sharerData,
  linkCopiedTranslationKey,
  linkCopiedFailedTranslationKey,
} from '../../../constants';
import CopyButtonWrapper from './CopyButtonWrapper';
import clsx from 'clsx';
import shareButtonStyles from './ShareButton.module.scss';
import { HAS_CUSTOM_FOCUS_CLASSNAME } from '@wix/editor-elements-common-utils';

const ShareButton: React.FC<IShareButtonProps> = ({
  id,
  platformId,
  value,
  label,
  illustration,
  url = '',
  translations,
}) => {
  const platformIdWithFallback = getPlatformIdWithFallback(platformId, value);
  const translatedCopyLinkLabel = translations[label];
  const buttonLabel =
    platformIdWithFallback === platformIds.copyButton && translatedCopyLinkLabel
      ? translatedCopyLinkLabel
      : label;

  return (
    <>
      {platformId === platformIds.copyButton ? (
        <CopyButtonWrapper
          id={id}
          url={url}
          ariaLabel={buttonLabel}
          tooltipTexts={{
            linkCopiedText: translations[linkCopiedTranslationKey],
            linkCopiedFailedText: translations[linkCopiedFailedTranslationKey],
          }}
          shareButtonIcon={
            <ShareButtonIcon
              className={clsx(shareButtonStyles.icon, 'icon')}
              svg={illustration?.svgId ?? ''}
            />
          }
          labelNode={
            <span className={clsx(shareButtonStyles.label, 'label')}>
              {buttonLabel}
            </span>
          }
        />
      ) : (
        <a
          id={id}
          className={clsx(
            shareButtonStyles.root,
            HAS_CUSTOM_FOCUS_CLASSNAME,
            'button',
          )}
          target="popup"
          href={url}
          onClick={event => {
            event.preventDefault();
            window.open(url, sharerData.name, sharerData.params);
          }}
          rel="noreferrer"
          data-testid={platformId}
          aria-label={buttonLabel}
        >
          <ShareButtonIcon
            className={clsx(shareButtonStyles.icon, 'icon')}
            svg={illustration?.svgId ?? ''}
          />
          <span className={clsx(shareButtonStyles.label, 'label')}>
            {buttonLabel}
          </span>
        </a>
      )}
    </>
  );
};

export default ShareButton;
